<template>
  <div class="index">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">支付宝支付设置</div>
      <el-form-item label="名称">
        <el-input v-model="form.name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="支付宝 appid">
        <el-input v-model="form.ali_app_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="支付宝 aes_key">
        <el-input v-model="form.aes_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="支付宝公钥">
        <el-input type="textarea" :rows="4" v-model="form.ali_alipayrsa_publickey" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="应用私钥">
        <el-input type="textarea" :rows="4" v-model="form.ali_rsa_privatekey" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import useApi from '@/api/useApi';
import { handleObj } from '@/utils/tools';

export default{
  data(){
    return{
      form: {
        name: "",
        ali_app_id: '',
        aes_key: '',
        ali_alipayrsa_publickey: '',
        ali_rsa_privatekey: ''
      }
    }
  },
  methods:{
    onSubmit: async function() {
      const { msg } = await useApi().update_zfb_config(this.form);
      this.$message.success(msg);
    },
    getDetail: async function() {
      const { data: { app } } = await useApi().get_zfb_config();
      handleObj.formatObj(app, this.form);
    },
  },
  created(){ this.getDetail() }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appzfb/index.vue